import Script from "next/script"

declare const initiateCall: () => {}

export function FreshdeskScript() {
  if (process.env.NODE_ENV !== "development") {
    return (
      <Script
        id="freshdesk"
        src="/scripts/freshdesk.js"
        onLoad={() => {
          initiateCall()
        }}
      />
    )
  }
}
